export default __webpack_public_path__ + "static/media/groups-defender.a1474aa0.svg";